import React, { useEffect, useState } from "react";

const ResponsiveLegend = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const getLegendPosition = () => {
    if (windowWidth >= 600) {
      return {
        position: "absolute",
        top: "50%",
        transform: "translate(0, -50%)",
      };
    } else {
      return null;
    }
  };

  return { getLegendPosition, windowWidth };
};

export default ResponsiveLegend;
